<ng-container *ngIf="product$ | async as product">
  <ng-container *ngIf="nonDefaultCategories(product.superCategories)">
    <div id="prod-variant-section" class="variant-section" *ngIf="variantsKeys.length > 0">
      <!-- <cx-variant-color-selector
      *ngIf="variants[variantType.COLOR]"
      [product]="product"
      [variants]="variants[variantType.COLOR]"
    ></cx-variant-color-selector> -->
      <div *ngFor="let key of variantsKeys; let i = index">
        <ng-container *ngIf="!singleOption">
          <app-variant-size-selector
            *ngIf="variants[key]"
            [product]="product"
            [title]="key"
            [isDesktop]="this.isDesktop"
            [variants]="variants[key]"
            [selectedVariantIndex]="selectedVariantIndex"
            [firstSelector]="i == 0"
            (parentUpdate)="update()"
            (isLoading)="isLoading()"
            (parentReload)="reload($event)"
          ></app-variant-size-selector>
        </ng-container>
      </div>
      <div *ngIf="loading" class="rotating"></div>
    </div>
  </ng-container>
</ng-container>
